import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { hashHistory } from 'react-router';

import Arrow from './arrow.jsx';
import OnboardingLink from './onboardingLink.jsx';

import StatusSummaryWrapper from './statusSummaryWrapper.jsx';

class StatusSummaryButton extends PureComponent {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        const { href } = this.props;
        hashHistory.push(href);
    }

    render() {
        const {
            children,
            statusSummary,
            actionRequiredType,
            withOnboarding,
        } = this.props;

        return (
            <StatusSummaryWrapper
                actionRequiredType={actionRequiredType}
                statusSummary={statusSummary}
            >
                {withOnboarding && (
                    <div className="r-mll">
                        <OnboardingLink />
                    </div>
                )}
                <div
                    role="link"
                    onClick={this.handleClick}
                    data-safe-trade-button
                    className="align-items-center bg-toothpaste flex justify-space-between licorice
                        phl pvm strong t4 clickable"
                >
                    <div className="r-mll r-prm">{children}</div>
                    <Arrow />
                </div>
            </StatusSummaryWrapper>
        );
    }
}

StatusSummaryButton.propTypes = {
    actionRequiredType: PropTypes.oneOf(['POSITIVE', 'NEGATIVE']),
    children: PropTypes.node.isRequired,
    href: PropTypes.string.isRequired,
    statusSummary: PropTypes.node,
    withOnboarding: PropTypes.bool,
};

export default StatusSummaryButton;



// WEBPACK FOOTER //
// ./safeTrade/status/statusSummaryButton.jsx